import { observer } from 'mobx-react';
import Barcode from 'react-barcode';

import { CopyButtonTranslation, GeneratBarcodeTranslation } from '../../../../localization/SiteTranslation';
import ActionButton from '../../../../shared/components/ActionButton';
import IconButton from '../../../../shared/components/Button/IconButton';
import Icon from '../../../../shared/components/Icon/Icon';
import CopyButton from '../CopyButton';
import css from './Ean13CodeShare.css';
import { Ean13CodeShareState } from './Ean13CodeShareState';

interface Ean13CodeShareProps {
  state: Ean13CodeShareState;
  isCodeLoading: boolean;
  className?: string;
  translation: GeneratBarcodeTranslation;
  copyButtonTranslation: CopyButtonTranslation;
}

const Ean13CodeShare = ({
  state,
  isCodeLoading,
  className,
  translation,
  copyButtonTranslation,
}: Ean13CodeShareProps) => {
  return (
    <div className={className}>
      <p>{translation.title}</p>
      {state.ean13code ? (
        <div className={css.result}>
          <Barcode
            className={css.barcode}
            margin={0}
            value={state.ean13code}
            format="EAN13"
            fontSize={14}
            width={1.4}
            height={25}
            fontOptions="bold"
          />
          <CopyButton
            className={css.copyButton}
            translation={copyButtonTranslation}
            valueToCopy={state.ean13code}
            disabled={isCodeLoading}
          />
        </div>
      ) : (
        <ActionButton
          className={css.button}
          buttonElement={IconButton}
          externalButtonProps={{ icon: <BarcodeIcon /> }}
          command={state.generateEan13CodeCommand}
        >
          {translation.button}
        </ActionButton>
      )}
    </div>
  );
};
export default observer(Ean13CodeShare);

const BarcodeIcon = () => <Icon name="barcodeScan" className={css.icon} />;
